<template>
  <div class="main-container">
    <div v-if="loading" class="loading-shell" aria-label="Chargement">
      <div class="loading-spinner" aria-hidden="true"></div>
    </div>
    <div v-else-if="error" class="state-card error-card">{{ error }}</div>
    <CardPortfolio
        v-for="item in portfolioItems"
        :key="item.id"
        v-bind="item"
    />
  </div>
</template>

<script>
import CardPortfolio from "@/components/CardPortfolio.vue";
import {GetRequest} from "@/services/request";

export default {
  components: {
    CardPortfolio
  },

  data: () => ({
    error: '',
    loading: true,
    portfolioItems: []
  }),

  async mounted() {
    try {
      this.portfolioItems = await GetRequest('portfolio-items');
    } catch (error) {
      this.error = 'Portfolio indisponible';
    } finally {
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.main-container {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(3, 1fr);
  align-items: stretch;
  max-width: 1200px;
  margin: 50px auto;
  padding: 0 1rem;
}

.state-card {
  background: #323336;
  border-radius: 20px;
  padding: 1.5rem;
}

.loading-shell {
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 6px solid rgba(255, 255, 255, 0.12);
  border-top-color: #00f0ff;
  animation: portfolio-spin 0.82s linear infinite;
}

.error-card {
  color: #ff8a8a;
}

@keyframes portfolio-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 1100px) {
  .main-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 650px) {
  .main-container {
    grid-template-columns: 1fr;
  }
}
</style>
